import * as MD from '@material-ui/core';
import * as React from 'react';
import { getTheme } from '../Themes';
import CloseIcon from '@material-ui/icons/Close';
import { I18N } from '../Store/I18n/Types';

import { Dispatch } from 'redux';
import { IApplicationState } from '../Store';
import { connect } from 'react-redux';

import MuiDialogTitle from '@material-ui/core/DialogTitle';
import Draggable  from 'react-draggable';
import Paper, { PaperProps } from '@material-ui/core/Paper';

const theme = getTheme();

const styles = MD.createStyles({
    closeButton: {
        position: 'absolute',
        right: '0px',
        top: '4px',
        color: theme.palette.grey[500],
      },
      
  formControl: {
    width: '100%',
    position:'absolute'
  },
  searchButton: {
    paddingLeft: '10px',
    paddingRight: '10px',
    paddingTop: '5px',
    paddingBottom: '5px',
    cursor:'pointer',
  },
  containerDivText:{
    textAlign:'center',
    display:'flex',
    justifyContent:'center',
    marginTop:'20px', 
    marginBottom:'20px', 
    fontSize:'16px'
  },
})
export interface DialogTitleProps extends MD.WithStyles<typeof styles> {
    id: string;
    children: React.ReactNode;
    onClose: () => void;
}
function PaperComponent(props: PaperProps) {
  return (
    <Draggable handle="#draggable-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}
const DialogTitle = MD.withStyles(styles)((props: DialogTitleProps) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography {...other} style={{cursor:'move', color: '#ffb54f', padding: theme.spacing(2), textAlign: 'center'}}>
        <MD.Typography >{children}</MD.Typography>
        {onClose ? (
          <MD.IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </MD.IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });

interface IState {
    open: boolean | null;
}
interface IPropsFromDispatch {
    
}
interface IPropsFromState {
    i18n: I18N;
}
interface IOwnProps {
  content: any,
  open: boolean,
  closeDialog: () => void;
  width: string;
  title?: string;
  showActions?: boolean;
}

type AllProps = 
    MD.WithStyles<typeof styles> &
    IPropsFromState &
    IPropsFromDispatch &
    IOwnProps;

export class DialogComponent extends React.Component<AllProps, IState> {
    public constructor(props: AllProps) {
        super(props);

        this.state = {
            open: null,
        }
    }

  public componentDidMount() {
  }

  public render() {
    return (
        <MD.Dialog 
            //disableBackdropClick 
            onClose={this.handleClose.bind(this)} 
            open={this.props.open}
            maxWidth='lg'
            style={{overflow:'hidden'}}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
          >
          <DialogTitle id="draggable-title" onClose={this.handleClose.bind(this)}>
            {this.props.title}
          </DialogTitle>
          <MD.DialogContent style={{padding: "2px 12px", width: this.props.width}} 
            dividers={this.props.title ? true : false}>
              <div
              className={typeof(this.props.content) === 'string' ? 
              this.props.classes.containerDivText : undefined}>
                  {this.props.content}
              </div>
            </MD.DialogContent>
          { this.props.showActions && 
          <MD.DialogActions>
              <MD.Button style={{textAlign:'center', width:'100%', color: theme.palette.primary.main}} 
              onClick={() => this.handleClose()} >
                  OKAY
              </MD.Button>
          </MD.DialogActions>
        }
        </MD.Dialog>
    );
  }

  private handleClose = () => {
    this.props.closeDialog()
  }
}

const mapStateToProps = ({ i18n }: IApplicationState) => ({
  i18n: i18n.i18n,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  
});

export const Dialog = connect(mapStateToProps, mapDispatchToProps)
                (MD.withStyles(styles)(DialogComponent));
